import * as React from "react";
import { Container } from "../../icons";
import { withVariationColors } from "../../colorVariations";
const SvgComponent = (
  { primaryColor, secondaryColor, title, titleId, fillColor, ...props },
  svgRef
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 80 80"
    aria-labelledby={titleId}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="none" fillRule="evenodd">
      <path
        fill={primaryColor}
        d="M80 40c0 22.092-17.909 40-40 40S0 62.092 0 40C0 17.909 17.909 0 40 0s40 17.909 40 40"
      />
      <path
        fill={secondaryColor}
        d="M68.166 30.426c5.568 4.389 6.02 11.635 3.218 16.461-2.749 4.735-7.988 7.248-13.33 6.282-1.156-.21-2.245-.792-3.36-1.215-.207-.079-.392-.217-.687-.385v.672l-.001 8.577c0 .719-.012.729-.743.73-1.639.001-3.278-.017-4.916.01-.532.009-.689-.179-.688-.697.01-10.578.01-21.156 0-31.734 0-.485.146-.654.652-.675 1.824-.074 3.373.474 4.567 1.93 1.128-.986 2.32-1.777 3.713-2.168 4.217-1.183 8.109-.52 11.575 2.212zm-41.263-1.97c1.83.024 3.659.007 5.488.01.692.002.813.19.528.837-3.224 7.334-6.457 14.665-9.674 22.003-.533 1.216-1.502 1.663-2.74 1.657-1.241-.006-2.173-.484-2.706-1.703-3.201-7.324-6.43-14.635-9.648-21.951-.295-.673-.183-.841.566-.843 1.467-.002 2.934.016 4.402-.005 1.106-.016 1.814.481 2.253 1.493 1.574 3.631 3.176 7.251 4.768 10.875.114.259.237.512.392.848.719-1.626 1.406-3.171 2.086-4.72 1.163-2.65 2.325-5.298 3.476-7.951.163-.375.367-.557.809-.55zm14.468 0c.517-.007.707.162.706.69-.01 7.586-.01 15.174 0 22.76 0 .5-.181.669-.672.663-1.659-.02-3.317-.006-4.975-.009-.717 0-.743-.027-.743-.737V29.234c0-.76.007-.767.767-.768 1.639-.001 3.279.015 4.917-.01zm18.784 5.542a6.502 6.502 0 00-6.503 6.509 6.49 6.49 0 006.486 6.518c3.653.012 6.544-2.858 6.547-6.5a6.478 6.478 0 00-6.53-6.527z"
      />
      <path d="M0 0h80v80H0z" />
    </g>
  </svg>
);
const SvgLogoVip = withVariationColors(
  ({ primaryColor, secondaryColor, fillColor, title, titleId, ...props }) => (
    <Container {...props}>
      <SvgComponent
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        fillColor={fillColor}
        title={title}
        titleId={titleId}
      />
    </Container>
  )
);
const MemoSvgLogoVip = React.memo(SvgLogoVip);
export default MemoSvgLogoVip;
